"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tag = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _utils = require("../../utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var Tag = _styledComponents["default"].span.withConfig({
  displayName: "Tagstyle__Tag",
  componentId: "u4vido-0"
})(function (_ref) {
  var theme = _ref.theme,
      variant = _ref.variant;
  var getColorByVariant = {
    primary: theme.color.brandPrimary.light,
    secondary: theme.color.brandSecondary.dark,
    warning: theme.color.feedback.alert,
    error: theme.color.feedback.error,
    success: theme.color.feedback.success,
    inactive: theme.color.neutral['03']
  }[variant];
  return _extends({
    display: 'inline-block',
    textAlign: 'center',
    background: "".concat(getColorByVariant, "14"),
    borderRadius: 50,
    color: getColorByVariant,
    padding: theme.spacing.inline['6xs'],
    minWidth: 62
  }, (0, _utils.getTextStyle)({
    theme: theme,
    variant: 'caption-02',
    margin: false
  }));
});

exports.Tag = Tag;